import _ from "lodash";
import tree from "../../state";
import { showError } from "../../actions/alertActions";
import * as playerActions from "../../actions/playerActions";
import PlayerPaths from "../../constants/paths/playerPaths";
import env from "../../constants/env";
import config from "../../config/config";
import * as awsS3 from "../s3";
import { normalizeActivity, getActivityLastUpdatedDateTime, createActivitySessionListItem, getExtension } from "../../utils/utils";

let publishMode = false;

export default class PersistenceManagerAmbifi {

	async init(params) {
		tree.set(PlayerPaths.ACTIVITIES, params.activities);

		let sessionFound = false;

		// This is now considering the alternative publish load which can take advantage of this persistence manager
		let activityId, activityIdentityId, activityInstanceId;

		if (params.activities) {
			const targetActivity = _.first(params.activities);
			activityId = targetActivity.id;
			publishMode = true;
			tree.set(PlayerPaths.ACTIVITIES, params.activities);
		} else {
			activityId = params.activityId;
			activityIdentityId = params.activityIdentityId;
			activityInstanceId = params.activityInstanceId;
		}


		//look up URL from sessions
		let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
		if (!_.isUndefined(sessions)) {
			let index = _.findIndex(sessions, { id: activityId, instanceId: activityInstanceId });
			if (index !== -1) {
				sessionFound = true;
			}
		}

		let promise;

		if (sessionFound) {
			promise = this.resumeActivity(tree, activityId, activityInstanceId, null, activityIdentityId);
		} else {
			promise = this.startNewActivity(tree, activityId, activityInstanceId, null);
		}

		return promise;
	}

	async printInstance(name, data, templateId) {
		if (!_.isUndefined(_.get(config, "persistence.printTemplate"))) {

			const res = await config.persistence.printTemplate(name, data, templateId, {});
			return res;
		} else {
			return Promise.resolve();
		}
	}

	async save(params = {}) {
		let activity = tree.get(PlayerPaths.ACTIVITY);
		return this.saveHistoryInstances([activity], params.overrides);
	}

	async saveAndExit() {
		let self = this;
		return new Promise((resolve, reject) => {
			self.save().then(() => {

				let activity = tree.get(PlayerPaths.ACTIVITY);

				if (activity.history.length > 0) {
					//update session data
					let activityId = activity.id;
					let activitySessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
					let idx = _.findIndex(activitySessions, { instanceId: activity.instanceId });

					if (idx > -1) {
						//update existing session
						let lastUpdatedDateTime = getActivityLastUpdatedDateTime(activity);
						tree.set(PlayerPaths.SESSION_LAST_UPDATED_DATE_TIME(activityId, idx), lastUpdatedDateTime);
					} else {
						let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
						if (_.isUndefined(sessions)) {
							tree.set(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId), []);
						}
						tree.unshift(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId), createActivitySessionListItem(activity));
					}
				}

				let event = {
					activity,
					sessions: tree.get(PlayerPaths.SESSIONS)
				}
				resolve(event);
			}).catch((err) => {
				reject(err);
			})
		});
	}

	async saveResponse() {
		console.log("Save response!");
	}

	restoreActivityResponsesAndState(activity) {
		console.log("Restore activity responses and state!");
		return activity;
	}

	async setCompletionState(completionState) {
		console.log("Set completion state to " + completionState);
	}

	async trackHistory(historyItem) {
		console.log("Track history item", historyItem);
	}

	async loadActivity(activityId, initialItemId, newSession = false) {
		let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));

		let promise;

		if (!_.isUndefined(sessions) && sessions.length > 0 && newSession === false) {
			promise = this.resumeActivity(tree, activityId, sessions[0].instanceId, initialItemId);
		} else {
			promise = this.startNewActivity(tree, activityId, null, initialItemId);
		}
		return promise;
	}

	async resumeActivity(tree, activityId, activityInstanceId, initialItemId, activityIdentityId) {

		let url;
		//look up URL from sessions
		let sessions = tree.get(PlayerPaths.SESSIONS_BY_ACTIVITY_ID(activityId));
		if (!_.isUndefined(sessions)) {
			let index = _.findIndex(sessions, { id: activityId, instanceId: activityInstanceId });
			if (index !== -1) {
				url = sessions[index].url;
			}
		}

		if (url !== null) {

			return awsS3.loadActivityInstanceFromS3(env.s3.contentBucket, url).then((result) => {
				playerActions.initializeActivity(tree, result, initialItemId);
				tree.set(PlayerPaths.SHOW_SPINNER, false);
				tree.set(PlayerPaths.SELECTED_ACTIVITY_IDENTITY_ID, activityIdentityId);
			}).catch((err) => {
				tree.set(PlayerPaths.SHOW_SPINNER, false);
				showError("Unable to resume activity", err);
			});
		} else {
			return Promise.resolve({});
		}
	}

	async startNewActivity(tree, activityId, activityInstanceId = null, initialItemId = null) {
		const playerActivities = tree.get(PlayerPaths.ACTIVITIES);

		tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

		let identityId = "";
		let activity = null;
		for (let i = 0; i < playerActivities.length; i++) {
			const playerActivity = playerActivities[i];

			if (playerActivity.id === activityId) {
				identityId = playerActivity.identityId;
				activity = playerActivity;
			}
		}

		if (publishMode && activity) {
			playerActions.initializeActivity(tree, normalizeActivity(activity), initialItemId);
			tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

			if (activityInstanceId !== null) {
				tree.set(PlayerPaths.ACTIVITY_PROPERTY("instanceId"), activityInstanceId);
			}

			let instance = tree.get(PlayerPaths.ACTIVITY);

			if (instance) {
				tree.set(PlayerPaths.SELECTED_ACTIVITY_INSTANCE_ID, instance.instanceId);
				tree.set(PlayerPaths.SHOW_SPINNER, false);
			}

			return true;
		} else {
			console.log("GET ACTIVITY", activityId);
			//need to get activity template and inject content	
			return awsS3.getActivity(activityId, identityId).then((activityResult) => {
				playerActions.initializeActivity(tree, normalizeActivity(activityResult), initialItemId);
				tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

				if (activityInstanceId !== null) {
					tree.set(PlayerPaths.ACTIVITY_PROPERTY("instanceId"), activityInstanceId);
				}

				let instance = tree.get(PlayerPaths.ACTIVITY);

				if (instance) {
					tree.set(PlayerPaths.SELECTED_ACTIVITY_INSTANCE_ID, instance.instanceId);
					tree.set(PlayerPaths.SHOW_SPINNER, false);
				}

			}).catch((err) => {
				console.error(err);
				showError("Unable to start new activity", err);
			});
		}
		
	}

	async saveHistoryInstances(obj, overrides = {}, refreshActivities = false) {
		// Array of instances to save to s3

		let instances = obj;
		let files = [];
		let errLog = [];

		let displayName = null;

		if (overrides.displayName) {
			displayName = overrides.displayName;
		} else {
			const member = tree.get(["selectedOrg", "member"]);
			if (member) {
				displayName = member.displayName;
			}
		}

		for (let i = 0; i < instances.length; i++) {
			//alert("Error " + i);
			try {
				let instance = instances[i];
				let lastTimestamp = (instance.history[0].timestamp).replace(" ", "T");
				let fileName = instance.id + "/" + lastTimestamp + "_" + instance.instanceId + ".json";
				instance.displayName = displayName;

				files.push({ fileName: fileName, fileContent: instance });
			} catch (e) {
				console.error(e);
				errLog.push(e);
			}
		}

		if (errLog.length > 0) {
			//alert(JSON.stringify(errLog, null, 2));
		}

		return awsS3.saveHistory(env.s3.contentBucket, files, overrides.keyPrefixOverride, refreshActivities);
	}

	async uploadMediaFile(fileData, fileName, targetType, identityId) {

		return new Promise((resolve, reject) => {
			awsS3.uploadMediaFileToS3(env.s3.userUploadBucket, fileData, identityId + "_" + fileName, targetType).then(() => {

				let ext = getExtension(fileName);
				let newExt;

				if (targetType === "video") {
					newExt = "mp4";
				} else {
					newExt = ext;
				}

				let fileNameNoExt = fileName.split('.').slice(0, -1).join('.');

				const key = `${identityId}/userAssets/${targetType}/${fileNameNoExt}.${newExt}`;
				const bucket = env.s3.contentBucket;

				awsS3.waitForKeyExists(bucket, key).then(() => {
					console.log("Found it!");
					resolve({ url: `https://s3.amazonaws.com/${bucket}/${key}` });
				}).catch(err => {
					console.error("Doesn't exist yet", err);
					reject(err);
				});
			}).catch(err => {
				console.error(err);
				reject(err);
			});
		});
	}
}
